import "../../styles/ReusableStyles/ArrowButton.css";

const ArrowButton = ({ direction = "right", onClick }) => {
  return (
    <button className={`arrow-button ${direction}`} onClick={onClick}>
      <img src="/ReadMoreArrow.svg" alt={`Arrow pointing ${direction}`} className="arrow-icon" width={16} height={16} />
    </button>
  );
};

export default ArrowButton;
